import React from 'react';
import { StyledTitle } from './tab-title.styles';
export const TabTitle = ({ label, count }) => (<StyledTitle>
    <span className="tab-title-label">{label}</span>
    {count && <span className="tab-title-count">{count}</span>}
  </StyledTitle>);
export default TabTitle;
